import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
	selector: 'ms-dashboard-stat-card',
	imports: [RouterLink, DecimalPipe, NgTemplateOutlet, FaDuotoneIconComponent],
	templateUrl: './dashboard-stat-card.component.html',
	styleUrl: './dashboard-stat-card.component.scss'
})
export class DashboardStatCardComponent {
	public title = input.required<string>();
	public value = input<number | undefined>(undefined);
	public icon = input.required<string>();
	public colorClass = input<string>('text-primary');
	public routerLink = input<string | undefined>(undefined);
	public isLoading = input<boolean>(false);
}
